import FooData from './FooData';
export default FooData;